import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "navMarkerName"];
import { NavMarker } from 'react-rhumb';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorPage = _ref => {
  let {
      children,
      navMarkerName
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ErrorMessage, Object.assign({
    illustrationProps: {
      width: 200
    }
  }, props, {
    children: children && /*#__PURE__*/_jsxs("p", {
      children: [children, /*#__PURE__*/_jsx(NavMarker, {
        name: navMarkerName
      })]
    })
  }));
};
export default ErrorPage;